import React, { useEffect ,useState} from "react";
import { Helmet } from "react-helmet";

import NavBar from "../components/common/navBar";
import Footer from "../components/common/footer";
import Logo from "../components/common/logo";
import AllProjects from "../components/projects/allProjects";
import Service from "../service/Service";


import "./styles/projects.css";

const Projects = () => {

	
	const [data, setData] = useState([]);
	
	useEffect(() => {
	  getData();
	}, []);
  
	const getData = async () => {
	  try {
		const documentData = await Service.getInfoById("project");
		if (documentData) {
		  setData(documentData);
		}
	  } catch (error) {
		console.error("Error fetching data:", error);
	  }
	};
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	

	return (
		<React.Fragment>
			

			<div className="page-content">
				<NavBar active="projects" />
				<div className="content-wrapper">
					<div className="projects-logo-container">
						<div className="projects-logo">
							<Logo width={46} />
						</div>
					</div>
					<div className="projects-container">
						<div className="title projects-title">
							{data.title}
						</div>

						<div className="subtitle projects-subtitle">
							{data.desc}
						</div>

						<div className="projects-list">
							<AllProjects />
						</div>
					</div>
					<div className="page-footer">
						<Footer />
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default Projects;
